// DO NOT EDIT -- generated from fs/services/llm-tool/answers.proto

import { RelevantObject } from './experiments.proto';
import { ChatMessage, LlmModel } from './llm.proto';
import * as alexa from '../alexa';
import * as funnelmetrics from '../../api/metrics/funnelmetrics';
import * as metrics from '../../api/metrics';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';

export namespace AnswersPublic {

  export const AnalyzeFunnelEndpoint = "/grpc/llm_tool.AnswersPublic/AnalyzeFunnel";
  export function AnalyzeFunnel(sender: (req: AnalyzeFunnelRequest, endpoint: string) => Promise<AnalyzeFunnelResponse>, req: AnalyzeFunnelRequest): { promise: () => Promise<AnalyzeFunnelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AnalyzeFunnelEndpoint),
      endpoint: AnalyzeFunnelEndpoint
    };
  }

  export const CollectFunnelContextEndpoint = "/grpc/llm_tool.AnswersPublic/CollectFunnelContext";
  /**
   * Useful for manually collecting context for a funnel and testing the LLM.
   * Not exposed for any system reasons.
   */
  export function CollectFunnelContext(sender: (req: CollectFunnelContextRequest, endpoint: string) => Promise<CollectFunnelContextResponse>, req: CollectFunnelContextRequest): { promise: () => Promise<CollectFunnelContextResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CollectFunnelContextEndpoint),
      endpoint: CollectFunnelContextEndpoint
    };
  }

  export const AnalyzeMetricEndpoint = "/grpc/llm_tool.AnswersPublic/AnalyzeMetric";
  export function AnalyzeMetric(sender: (req: AnalyzeMetricRequest, endpoint: string) => Promise<AnalyzeMetricResponse>, req: AnalyzeMetricRequest): { promise: () => Promise<AnalyzeMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AnalyzeMetricEndpoint),
      endpoint: AnalyzeMetricEndpoint
    };
  }

  export const RenderQueryEndpoint = "/grpc/llm_tool.AnswersPublic/RenderQuery";
  /** one-shot query planning and execution */
  export function RenderQuery(sender: (req: RenderQueryRequest, endpoint: string) => Promise<RenderQueryResponse>, req: RenderQueryRequest): { promise: () => Promise<RenderQueryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, RenderQueryEndpoint),
      endpoint: RenderQueryEndpoint
    };
  }

  export const RenderQueryPlanEndpoint = "/grpc/llm_tool.AnswersPublic/RenderQueryPlan";
  /**
   * query plan + query execution is a pair of APIs to collaborate with user for
   * a query plan and then execute it
   */
  export function RenderQueryPlan(sender: (req: RenderQueryPlanRequest, endpoint: string) => Promise<RenderQueryPlanResponse>, req: RenderQueryPlanRequest): { promise: () => Promise<RenderQueryPlanResponse>, endpoint: string } {
    return {
      promise: () => sender(req, RenderQueryPlanEndpoint),
      endpoint: RenderQueryPlanEndpoint
    };
  }

  export const RenderQueryExecutionEndpoint = "/grpc/llm_tool.AnswersPublic/RenderQueryExecution";
  export function RenderQueryExecution(sender: (req: RenderQueryExecutionRequest, endpoint: string) => Promise<RenderQueryExecutionResponse>, req: RenderQueryExecutionRequest): { promise: () => Promise<RenderQueryExecutionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, RenderQueryExecutionEndpoint),
      endpoint: RenderQueryExecutionEndpoint
    };
  }

  export const ChatVaidomEndpoint = "/grpc/llm_tool.AnswersPublic/ChatVaidom";
  export function ChatVaidom(sender: (req: ChatVaidomRequest, endpoint: string) => Promise<ChatVaidomResponse>, req: ChatVaidomRequest): { promise: () => Promise<ChatVaidomResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ChatVaidomEndpoint),
      endpoint: ChatVaidomEndpoint
    };
  }

  export const GenerateChartEndpoint = "/grpc/llm_tool.AnswersPublic/GenerateChart";
  export function GenerateChart(sender: (req: GenerateChartRequest, endpoint: string) => Promise<GenerateChartResponse>, req: GenerateChartRequest): { promise: () => Promise<GenerateChartResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateChartEndpoint),
      endpoint: GenerateChartEndpoint
    };
  }

  export const KnowledgeBaseQueryEndpoint = "/grpc/llm_tool.AnswersPublic/KnowledgeBaseQuery";
  export function KnowledgeBaseQuery(sender: (req: KnowledgeBaseQueryRequest, endpoint: string) => Promise<KnowledgeBaseQueryResponse>, req: KnowledgeBaseQueryRequest): { promise: () => Promise<KnowledgeBaseQueryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, KnowledgeBaseQueryEndpoint),
      endpoint: KnowledgeBaseQueryEndpoint
    };
  }

  export const ChatVaidomInitialMessageEndpoint = "/grpc/llm_tool.AnswersPublic/ChatVaidomInitialMessage";
  export function ChatVaidomInitialMessage(sender: (req: ChatVaidomInitialMessageRequest, endpoint: string) => Promise<ChatVaidomInitialMessageResponse>, req: ChatVaidomInitialMessageRequest): { promise: () => Promise<ChatVaidomInitialMessageResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ChatVaidomInitialMessageEndpoint),
      endpoint: ChatVaidomInitialMessageEndpoint
    };
  }

  export const ModifyChartEndpoint = "/grpc/llm_tool.AnswersPublic/ModifyChart";
  export function ModifyChart(sender: (req: ModifyChartRequest, endpoint: string) => Promise<ModifyChartResponse>, req: ModifyChartRequest): { promise: () => Promise<ModifyChartResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ModifyChartEndpoint),
      endpoint: ModifyChartEndpoint
    };
  }

  export const RefinePromptEndpoint = "/grpc/llm_tool.AnswersPublic/RefinePrompt";
  export function RefinePrompt(sender: (req: RefinePromptRequest, endpoint: string) => Promise<RefinePromptResponse>, req: RefinePromptRequest): { promise: () => Promise<RefinePromptResponse>, endpoint: string } {
    return {
      promise: () => sender(req, RefinePromptEndpoint),
      endpoint: RefinePromptEndpoint
    };
  }

  export const FindSessionEndpoint = "/grpc/llm_tool.AnswersPublic/FindSession";
  export function FindSession(sender: (req: FindSessionRequest, endpoint: string) => Promise<FindSessionResponse>, req: FindSessionRequest): { promise: () => Promise<FindSessionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FindSessionEndpoint),
      endpoint: FindSessionEndpoint
    };
  }

  export const CollectSegmentContextEndpoint = "/grpc/llm_tool.AnswersPublic/CollectSegmentContext";
  export function CollectSegmentContext(sender: (req: CollectSegmentContextRequest, endpoint: string) => Promise<CollectSegmentContextResponse>, req: CollectSegmentContextRequest): { promise: () => Promise<CollectSegmentContextResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CollectSegmentContextEndpoint),
      endpoint: CollectSegmentContextEndpoint
    };
  }
}

export interface AnalyzeFunnelRequest {
  orgId: string;
  conversationId: string;
  llmModel: LlmModel;
  funnelId: string;
  prompt: string;
}

export interface AnalyzeFunnelResponse {
  response: string;
}

export interface AnalyzeMetricRequest {
  orgId: string;
  conversationId: string;
  llmModel: LlmModel;
  metricId: string;
  prompt: string;
}

export interface AnalyzeMetricResponse {
  response: string;
}

export interface CollectFunnelContextRequest {
  orgId: string;
  conversationId: string;
  funnelId: string;
  conversionComputation: boolean;
  trendComputation: boolean;
  opportunities: boolean;
  dropoffSummaries: number[];
  conversionRatesByDimension: metrics.Dimension[];
}

export interface CollectFunnelContextResponse {
  funnelDefinition: search_settings.Funnel | null;
  conversionComputation: funnelmetrics.FunnelDataTables | null;
  trendComputation: funnelmetrics.FunnelDataTables | null;
  opportunities: alexa.Opportunity[];
  dropoffSummaries: string[];
  conversionRatesByDimension: funnelmetrics.FunnelDataTables[];
}

export interface RenderQueryRequest {
  orgId: string;
  conversationId: string;
  prompt: string;
}

export interface RenderQueryResponse {
  orgId: string;
  conversationId: string;
  prompt: string;
  renderedQuery: string;
}

export interface RenderQueryPlanRequest {
  messages: ChatMessage[];
  orgId: string;
  conversationId: string;
}

export interface RenderQueryPlanResponse {
  messages: ChatMessage[];
  planAccepted: boolean;
  chartType: string;
}

export interface RenderQueryExecutionRequest {
  messages: ChatMessage[];
  orgId: string;
  conversationId: string;
  chartType: string;
}

export interface RenderQueryExecutionResponse {
  messages: ChatMessage[];
  renderedQuery: string;
}

export interface ChatVaidomRequest {
  messages: ChatMessage[];
  orgId: string;
  conversationId: string;
}

export interface ChatVaidomResponse {
  messages: ChatMessage[];
}

export interface MockChart {
  id: string;
  type: string;
  name: string;
  definition: string;
  data: string;
}

export interface KnowledgeBaseQueryRequest {
  orgId: string;
  messages: ChatMessage[];
  /** for testing, we can override the system prompt */
  systemPrompt: string;
  llmModel: LlmModel;
}

export interface KnowledgeBaseQueryResponse {
  response: string;
  links: string[];
}

export interface RelevantObjects {
  pages: RelevantObject[];
  elements: RelevantObject[];
  definedEvents: RelevantObject[];
  apiEvents: RelevantObject[];
  segments: RelevantObject[];
}

export interface GenerateChartRequest {
  orgId: string;
  conversationId: string;
  prompt: string;
  /** if chart type is provided, we will generate that chart type. If not, */
  chartType: string;
  /**
   * optional RAG objects to include in the chart.
   * if provided, we will use these objects to generate the chart.
   * if not provided, we will retrieve our own RAG objects.
   */
  relevantObjects: RelevantObjects | null;
  /** if true, rewrite the user's prompt to be more specific and accurate. */
  refinePrompt: boolean;
  /** if true, summarize the reasoning for the chart. */
  summarizeReasoning: boolean;
}

export interface GenerateChartResponse {
  chartId: string;
  chartType: string;
  reasoning: string;
}

export interface ChatVaidomInitialMessageRequest {
  orgId: string;
  conversationId: string;
}

export interface ChatVaidomInitialMessageResponse {
  message: string;
  suggestedMessages: string[];
}

export interface ModifyChartRequest {
  orgId: string;
  chartId: string;
  chartType: string;
  prompt: string;
  conversationId: string;
}

export interface ModifyChartResponse {
  chartId: string;
  chartType: string;
  reasoning: string;
}

export interface RefinePromptRequest {
  orgId: string;
  conversationId: string;
  prompt: string;
  relevantObjects: RelevantObjects | null;
}

export interface RefinePromptResponse {
  refinedPrompt: string;
  reasoning: string;
}

export interface FindSessionRequest {
  orgId: string;
  messages: ChatMessage[];
  llmModel: LlmModel;
}

export interface FindSessionResponse {
  response: string;
  segment: segment.SegmentDefinition | null;
  raw: string;
}

export interface CollectSegmentContextRequest {
  orgId: string;
  segmentDefinition?: segment.SegmentDefinition | null;
  segmentId?: string;
}

export namespace CollectSegmentContextRequest {
  export enum segment_id_or_definition {
    segmentDefinition = 2,
    segmentId = 3
  }

  export function segment_id_or_definition_oneof(m: CollectSegmentContextRequest): { opt: segment_id_or_definition.segmentDefinition, val: segment.SegmentDefinition } | { opt: segment_id_or_definition.segmentId, val: string } | null {
    if (m.segmentDefinition != null) { return { opt: segment_id_or_definition.segmentDefinition, val: m.segmentDefinition } }
    if (m.segmentId != null) { return { opt: segment_id_or_definition.segmentId, val: m.segmentId } }
    return null;
  }
}

export interface CollectSegmentContextResponse {
  response: string;
}
